import {fetchSceduledCareActivities} from "../QueryFunctions/CarePlanTimeline";
import { useQuery } from '@tanstack/react-query';

export const useCarePlan = (short_code) => {
    const queryIndex = ['carePlan', short_code];
    return useQuery(queryIndex, ()=>fetchSceduledCareActivities(short_code), {cacheTime: 0})
}